export const GET_BOT_CURRENT_STATE = "/config/chatStateInfo/:psid"
export const GET_THEME_CONFIG = "/config/botConfig/:tenantId"
export const END_CHAT = "/conversation/end/:sessionId"
export const SEND_FEEDBACK = "/conversation/feedback/:sessionId"
export const MARK_FLAG_ON_MESSAGE = "/conversation/feedback/flagchat"
export const MESSAGE_UPVOTE_DOWNVOTE = "/conversation/message/rating"
export const CHAT_HISTORY = "/conversation/history"
export const GET_CHAT_LOGS = "/conversation/history/:sessionId"
